<template>
  <div class="s-top-nav-container">
    <div class="s-logo-wrap"  @click="toHomePage">
      <img src="../assets/image/index/logo.png" alt class="logo" />
      <span class="s-nav-title">福安茶叶社会化服务平台</span>
    </div>
    <div class="s-nav-list">
      <div v-for="item in navList" :key="item.id" class="s-nav-item" @click="handleNav(item)" @mouseover="hover(item)" @mouseout="hoverOut(item)">
        <div>
          <span class="s-nav-item-name">{{ item.name }}</span>
          <div class="s-border-bottom" v-show="item.url == currentUrl || (item.url =='/financialInsurance' && currentUrl =='/insurance')"></div>
        </div>
        <div class="tab-nav" v-show="item.name == '金融保险' && isShow">
          <p class="tab-nav-name" @click="handleTabNav('/financialInsurance')" :class="currentUrl =='/financialInsurance'?'tab-nav-nameActive':''">金融服务</p>
          <p class="tab-nav-name" @click="handleTabNav('/insurance')" :class="currentUrl =='/insurance'?'tab-nav-nameActive':''">保险服务</p>
        </div>
      </div>
    </div>
    <div class="s-nav-login" v-show="isLogin == false">
      <span class="s-nav-login-name login-name-bg" @click="goLogin('登录')">登录</span>
      <span class="s-nav-login-name" @click="goLogin('注册')">注册</span>
    </div>
    <register-login></register-login>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../utils/js/eventBus.js";
import registerLogin from "../components/registerLogin.vue";
export default {
  name: "top-nav",
  components: { registerLogin },
  data() {
    return {
      currentUrl: "index",
      navList: [
        // { id: 0, name: "首页", url: "/index" },
        // { id: 1, name: "价格行情", url: "/priceQuotation" },
        // { id: 2, name: "金融服务", url: "/financialInsurance" },
        // { id: 3, name: "交易撮合", url: "/dealmakers" },
        // { id: 4, name: "专业咨询", url: "/professionalInfoConsultation" },
        // { id: 5, name: "信息资讯", url: "/information" },
        // { id: 6, name: "个人中心", url: "/personalCenter" }
      ],
      // loginDialog:false
      isLogin: false,
      isShow: false,
    };
  },
  created() {
    // console.log(this.$store.state.isLogin, "daohang");
    this.isLogin = this.$store.state.isLogin;
    if (this.$store.state.isLogin == "true") {
      this.navList = [
        { id: 0, name: "首页", url: "/index" },
        { id: 1, name: "价格行情", url: "/priceQuotation" },
        { id: 2, name: "金融保险", url: "/financialInsurance" },
        { id: 3, name: "交易撮合", url: "/dealmakers" },
        { id: 4, name: "专业咨询", url: "/professionalInfoConsultation" },
        { id: 9, name: "农技技术", url: "/agriculture" },
        { id: 5, name: "信息资讯", url: "/information" },
        // { id: 8, name: "病虫害", url: "/diseasesInsectPests" },
        { id: 11, name: "病虫害库", url: "/resourceLibrary" },
        { id: 10, name: "数据应用", url: "/modelApplication" },
        { id: 6, name: "个人中心", url: "/personalCenter" },
        { id: 7, name: "退出", url: "/outLogin" },
      ];
    } else {
      this.navList = [
        { id: 0, name: "首页", url: "/index" },
        { id: 1, name: "价格行情", url: "/priceQuotation" },
        { id: 2, name: "金融保险", url: "/financialInsurance" },
        { id: 3, name: "交易撮合", url: "/dealmakers" },
        { id: 4, name: "专业咨询", url: "/professionalInfoConsultation" },
        { id: 9, name: "农技技术", url: "/agriculture" },
        { id: 5, name: "信息资讯", url: "/information" },
        // { id: 8, name: "病虫害", url: "/diseasesInsectPests" },
        // 专业咨询
        { id: 11, name: "病虫害库", url: "/resourceLibrary" },
        { id: 10, name: "数据应用", url: "/modelApplication" },
        // { id: 6, name: "登录/注册", url: "/login" },
      ];
    }
  },
  mounted() {
    this.currentUrl = this.$route.path;
    this.navList.forEach((item) => {
      if (this.currentUrl.indexOf(item.url) >= 0) {
        this.currentUrl = item.url;
      }
    });
    eventBus.$on("hasLogin", (msg) => {
      if (msg) {
        this.isLogin = true;
        this.navList = [
          { id: 0, name: "首页", url: "/index" },
          { id: 1, name: "价格行情", url: "/priceQuotation" },
          { id: 2, name: "金融保险", url: "/financialInsurance" },
          { id: 3, name: "交易撮合", url: "/dealmakers" },
          { id: 4, name: "专业咨询", url: "/professionalInfoConsultation" },
          { id: 5, name: "信息资讯", url: "/information" },
          { id: 6, name: "个人中心", url: "/personalCenter" },
          { id: 7, name: "退出", url: "/outLogin" },
        ];
      }
      this.currentUrl = this.$route.path;
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      } else {
        location.reload();
      }
    });
  },
  methods: {
    toHomePage() {
      // window.location.href = this.logoUrl;
      window.location.href = Vue.prototype.systemHomeUrl;
    },
    handleNav(item) {
      console.log("");
      if (
        item.url == "/financialInsurance" &&
        this.currentUrl == "/insurance"
      ) {
        return false;
      }
      this.$nextTick(() => {
        this.currentUrl = item.url;
      });
      // if (item.name == "登录/注册") {
      //   eventBus.$emit("loginClick", true);
      //   // this.loginDialog = true;
      // } else
      if (item.name == "退出") {
        localStorage.clear();
        location.reload();
      } else {
        this.$router.push({ path: item.url });
      }
    },
    handleTabNav(url) {
      this.currentUrl = url;
      this.$router.push({ path: url });
    },
    goLogin(type) {
      eventBus.$emit("loginClick", true, type);
      // if(type == '登录'){

      // }else{

      // }
    },
    hover(item) {
      if (item.name == "金融保险") {
        this.isShow = true;
      }
    },
    hoverOut(item) {
      if (item.name == "金融保险") {
        this.isShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.s-top-nav-container {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  position: fixed;
  top: 0;
  z-index: 9;
  .s-logo-wrap {
    // width: 42%;
    // width: 30%;
    line-height: 80px;
    font-weight: 700;
    color: #fff;
    margin-right: 100px;
    cursor: pointer;
    // text-align: center;
    .s-nav-title {
      font-size: 30px;
      letter-spacing: 1px;
    }
    .logo {
      vertical-align: middle;
      margin-right: 10px;
      width: 45px;
      height: 50px;
      margin-top: -10px;
      margin-left: 40px;
    }
  }
  .s-nav-list {
    display: flex;
    justify-content: flex-start;
    .s-nav-item {
      height: 76px;
      line-height: 76px;
      position: relative;
      color: #fff;
      padding: 0 25px;
      // width: 120px;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
      .s-nav-item-name {
        display: inline-block;
        font-size: 18px;
      }
      .tab-nav {
        position: absolute;
        background: rgb(255, 255, 255);
        color: rgb(51, 51, 51);
        width: 100px;
        padding: 10px 0px;
        border-radius: 6px;
        left: 10px;
        top: 70px;
        .tab-nav-name {
          color: #333;
          line-height: 30px;
          font-size: 16px;
        }
        .tab-nav-nameActive {
          font-weight: bold;
          color: #6baf6f;
        }
        .tab-nav-name:hover {
          color: #6baf6f;
          font-weight: bold;
        }
      }
    }
    .s-border-bottom {
      position: relative;
      width: 20px;
      height: 3px;
      background-color: #fff;
      border-radius: 4px;
      left: 50%;
      margin-left: -10px;
    }
  }
  .s-nav-login {
    display: flex;
    justify-content: flex-end;
    .s-nav-login-name {
      height: 36px;
      line-height: 36px;
      color: #fff;
      padding: 0 15px;
      // width: 120px;
      text-align: center;
      display: inline-block;
      font-size: 18px;
      margin-top: 18px;
      cursor: pointer;
    }
    .login-name-bg {
      margin-left: 50px;
      background: linear-gradient(90deg, #8bdf49, #00be39);
      margin-right: 10px;
      border-radius: 6px;
    }
  }
}
</style>
